import timePickerTemplate from './bb_date_time_picker.html';
import './timepicker.html'; //used directly in template

function bbDateTimePickerController($scope, GeneralOptions, BlockTimeOptions, $filter) {
    'ngInject';

    if ($scope.format == null) {
        $scope.format = 'dd/MM/yyyy';
    }

    if ($scope.bbDisabled == null) {
        $scope.bbDisabled = false;
    }

    // Default minuteStep value
    if (!$scope.minuteStep) {
        $scope.minuteStep = GeneralOptions.calendar_minute_step;
    }

    // Default showMeridian value
    if (!$scope.showMeridian) {
        $scope.showMeridian = GeneralOptions.twelve_hour_format;
    }

    // Watch for changes in the timepicker and reassemble the new datetime
    $scope.$watch('datetimeWithNoTz', (newValue, oldValue) => {
        if ((newValue) && moment(newValue).isValid() && (oldValue == null || newValue.getTime() !== oldValue.getTime())) {
            const assembledDate = moment();
            assembledDate.set({
                year: parseInt(newValue.getFullYear()),
                month: parseInt(newValue.getMonth()),
                date: parseInt(newValue.getDate()),
                hour: parseInt(newValue.getHours()),
                minute: parseInt(newValue.getMinutes()),
                second: 0,
                milliseconds: 0
            });

            return $scope.date = assembledDate;
        }

        if ((newValue !== oldValue) && $scope.timeDurationHelper) {
            $scope.currentDuration = findOrAddDuration();
            $scope.duration = $scope.currentDuration.value;
        }

    });

    const clearTimezone = function (date) {

        if (moment(date).isValid()) {
            date = moment(date);
            const newDate = moment().tz('Etc/UTC');
            newDate.set(date.toObject());
            const newDateNoTimeZone = newDate.toISOString().replace('Z', '');
            return new Date(newDateNoTimeZone);
        }

        // Otherwise undefined (important for timepicker)
        return undefined;
    };

    $scope.datetimeWithNoTz = clearTimezone($scope.date);

    $scope.$watch('date', (newValue, oldValue) => {
        if ((newValue !== oldValue) && (clearTimezone(newValue) !== oldValue)) {
            $scope.datetimeWithNoTz = clearTimezone(newValue);
            return $scope.datetimeWithNoTz;
        }
    });

    $scope.$watch('minDate', (newValue, oldValue) => {
        if (newValue !== oldValue) {
            if ((newValue !== oldValue) && $scope.timeDurationHelper) {
                $scope.currentDuration = findOrAddDuration();
                $scope.duration = $scope.currentDuration.value;
            }
            $scope.minDateClean = clearTimezone(newValue);
            return $scope.minDateClean;
        }
    });

    $scope.$watch('maxDate', (newValue, oldValue) => {
        if (newValue !== oldValue) {
            $scope.maxDateClean = clearTimezone(newValue);   
            return $scope.maxDateClean;  
        }
    });

    $scope.minDateClean = clearTimezone($scope.minDate);
    $scope.maxDateClean = clearTimezone($scope.maxDate);

    if ($scope.timeDurationHelper) {
        $scope.durations = getDurations();
        $scope.currentDuration = findOrAddDuration();
        $scope.duration = $scope.currentDuration.value;
        $scope.onDurationHelperChanged = onDurationHelperChanged;
    }

    function getDurations() {
        const maxDiff = $scope.maxDate.diff($scope.minDate, 'minutes');
        const durations = BlockTimeOptions.blockTimeDurations.map((item) => {
            item.label = $filter('time_period')(item.value);
            if (item.value > maxDiff) item.disabled = true;
            return item;
        });

        return durations;
    }

    function findOrAddDuration() {
        const getCurrent = () => $scope.durations.find(item => item.value === getCurrentDuration().value);
        let currentDuration = getCurrent();
        if (!currentDuration) {
            updateDurations();
            currentDuration = getCurrent();
        }
        return currentDuration;
    }

    function updateDurations() {
        $scope.durations = $scope.durations.filter(item => !item.custom);
        $scope.durations.push(getCurrentDuration());
    }

    function getCurrentDuration() {
        const durationDifferenceInMinutes = $scope.date.diff($scope.minDate, 'minutes');
        const hours = durationDifferenceInMinutes / 60 | 0;
        const minutes = durationDifferenceInMinutes % 60 | 0;

        const hoursLabel = hours ? `${hours} Hours` : '';
        const minutesLabel = minutes ? `${minutes} Minutes` : '';

        const duration = {
            custom: true,
            value: durationDifferenceInMinutes,
            label: `${hoursLabel} ${minutesLabel}`
        };
        return duration;
    }

    function onDurationHelperChanged() {
        $scope.duration = $scope.currentDuration.value;
        $scope.durations = $scope.durations.filter(item => !item.custom);
        $scope.date = $scope.minDate.clone().add($scope.currentDuration.value, 'minutes');
    }

}

function bbDateTimePickerDirective() {
    return {
        scope: {
            date: '=',
            showMeridian: '=?',
            minuteStep: '=?',
            minDate: '=?',
            maxDate: '=?',
            format: '=?',
            dateOnly: '=?',
            dateReadonly: '=?',
            timeDurationHelper: '=?',
            duration: '=?',
            bbDisabled: '=?'
        },
        restrict: 'A',
        templateUrl: timePickerTemplate.id,
        controller: bbDateTimePickerController
    };
}

/***
 * @ngdoc directive
 * @name BB.directive:bbDateTimePicker
 * @scope
 * @restrict A
 *
 * @description
 * DateTime picker that combines date & timepicker and consolidates
 * the Use of Moment.js in the App and Date in the pickers
 *
 * @param {object}  date   A moment.js date object
 * @param {boolean}  showMeridian   Switch to show/hide meridian (optional, default:false)
 * @param {number}  minuteStep Step for the timepicker (optional, default:10)
 * @param {object}  minDate Min date value for datetimepicker
 * @param {object}  maxDate Max date value for datetimepicker
 */
angular
    .module('BB')
    .directive('bbDateTimePicker', bbDateTimePickerDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/date-time-picker/date_time_picker.directive.js